import homePageLayouts from 'modules/Home/layouts';
import footballPageLayouts from 'modules/Football/layouts';
import horseRacingPageLayouts from 'modules/HorseRacing/layouts';
import greyhoundRacingPageLayouts from 'modules/GreyhoundRacing/layouts';
import insiderLayouts from 'modules/Insider/layouts';
import privacyLayouts from 'modules/PrivacyPolicy/layouts'

import newsPageLayouts from 'modules/News/layouts';
import errorLayouts from 'modules/Errors/layouts';

import { genericSportLayout } from 'utils/layoutUtils';
import { buildPath } from 'utils/commonUtils';

const cricketPageLayouts = genericSportLayout('cricket');
const dartsPageLayouts = genericSportLayout('darts');
const golfPageLayouts = genericSportLayout('golf');
const boxingPageLayouts = genericSportLayout('boxing');
const formula1PageLayouts = genericSportLayout('formula1');
const nflPageLayouts = genericSportLayout('nfl');
const rugbyLeaguePageLayouts = genericSportLayout('rugby-league');
const rugbyUnionPageLayouts = genericSportLayout('rugby-union');
const snookerPageLayouts = genericSportLayout('snooker');
const tennisPageLayouts = genericSportLayout('tennis');
const otherSportsPageLayouts = genericSportLayout('other-sports');

const layouts = {
  ...homePageLayouts,
  ...footballPageLayouts,
  ...horseRacingPageLayouts,
  ...greyhoundRacingPageLayouts,
  ...cricketPageLayouts,
  ...dartsPageLayouts,
  ...golfPageLayouts,
  ...rugbyLeaguePageLayouts,
  ...rugbyUnionPageLayouts,
  ...tennisPageLayouts,
  ...boxingPageLayouts,
  ...formula1PageLayouts,
  ...snookerPageLayouts,
  ...nflPageLayouts,
  ...otherSportsPageLayouts,
  ...newsPageLayouts,
  ...errorLayouts,
  ...insiderLayouts,
  ...privacyLayouts
};

/*
  Arguments are provided by LayoutManager. All are mandatory
    layout is possibly via a connection to Redux
    context is an object containing useful contextual data, such as `params` or the entire redux `state`
    path is the parametrised routing path of the page

*/
export function getLayout(layout, context, path) {
  /*

  layoutComponents will either be an object with the following properties, or a function that returns one.

  section:
    This is mainly used for the GPT ads. It is optional and if omitted will default to the "sport" part of the URL

  bannerAd:
    The main (GPT served) advert that sits full width immediately underneath the header
    An object with `adUnitPath` and `type` properties

  leaderboardAd:
    Fresh 8 advert that is fixed to the bottom of the screen on Mobile
    An object with a `view` property

  components:
    will be an array of component specification objects, each of which has the following structure

    component:
      a mandatory string giving the component name, as specified in the routing for the relevant page

    props:
      optional object of props to send to the instatiated component

    desktopColumn:
      a string containing "left" or "right" to indicate which column the component shoudl appear in for desktop layout.
      Optional, defaulting to "left" if omitted (or indeed, if set to anything other than "right")

    desktopOrder:
    handheldOrder:
      These can be a number, boolean false, or omitted. It indicates the display order for the relevant layout.
      Ordering is done by CSS Flexbox.
      If a number is given, the compnent will be given it as a CSS order propery.
      If omitted the component will not have a CSS order property. If you mix components
        with and without an order, you might not get the results you want.
      If boolean false is given, the component will be hidden with display: false;

  */

  const layoutComponents = layouts[path];

  if (typeof layoutComponents == 'function') {
    return layoutComponents(layout, context);
  } else {
    return layoutComponents;
  }
}

export function preventLoadData(component, context) {
  const {state, routes} = context;
  const path = buildPath(routes);

  const layout = state.common.layout
              && state.common.layout[path]
              && state.common.layout[path].layout;

  if (!layout) {
    return false;
  }

  const components = getLayout(layout, context, path).components;

  return !components.some(someComponent => {
     return someComponent.component == component;
   });
}



// WEBPACK FOOTER //
// ./layouts.js